/**
 * Centered full-page note. Same markup as `FullPageNote` in
 * src/components/auth-guard.tsx (which isn't exported); used by the error and
 * not-found boundaries so failure states look like "Access pending approval".
 */
export function StatusNote({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-svh items-center justify-center p-6">
      <div className="w-full max-w-sm text-center">{children}</div>
    </div>
  );
}
